import { render } from "./CxResetForm.vue?vue&type=template&id=9bd47eca&ts=true"
import script from "./CxResetForm.vue?vue&type=script&lang=ts"
export * from "./CxResetForm.vue?vue&type=script&lang=ts"

import "./CxResetForm.vue?vue&type=style&index=0&id=9bd47eca&lang=less"

import exportComponent from "C:\\hexagon_develop\\hexagon_develop\\conx-ui\\microfrontends\\conx-ui-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__